import './home.css';
import { useState, useContext } from 'react';
import { UserContext } from '../context/UserContext';
import PartnerLogoCarousel from '../components/PartnerLogoCarousel';

export default function Partners() {
  const { user } = useContext(UserContext);
  const faqs = [
    { q: 'Wie kann man Partner werden?', a: 'Einfach mit kurzer Vorstellung & Ziel per Kontaktformular melden – wir prüfen Passung.' },
    { q: 'Gibt es Exklusivität?', a: 'Nur in seltenen Fällen bei speziellen Projekten – Standard ist offene, faire Zusammenarbeit.' },
    { q: 'Was kostet eine Kooperation?', a: 'Hängt von Umfang, Ressourcen und Art der Zusammenarbeit ab – wir klären alles transparent.' },
    { q: 'Wie lange dauert die Prüfung?', a: 'In der Regel 5–10 Werktage – abhängig von Komplexität & Kapazität.' }
  ];
  const [openFaq, setOpenFaq] = useState(null); // match B2B/Jobs pattern: none open initially
  const toggleFaq = (i) => setOpenFaq(openFaq === i ? -1 : i);
  return (
    <div className="home-page">
      {/* Hero */}
      <section id="top" className={user ? 'hero-offset-if-sidebar' : ''} style={{ width:'100vw', margin:0, padding:0 }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Unsere Partner</h2>
        <p className="hero-desc" style={{ textAlign: 'center', margin:'0 auto 24px', maxWidth:760 }}>
          Gemeinsam stärker: Wir kooperieren mit ausgewählten Partnern, Plattformen, Services und Creators – basierend auf
          Qualität, Integrität und nachhaltigem Mehrwert für alle Beteiligten.
        </p>
        {/* Logo Carousel (prominent under hero) */}
        {/* Das Logo Carousel wird konfiguriert über die Komponente PartnerLogoCarousel unter frontend/src/components/PartnerLogoCarousel.jsx */}
        <div style={{ maxWidth:1100, margin:'0 auto', padding:'10px 16px 28px 16px' }}>
          <PartnerLogoCarousel />
        </div>
      </section>

      {/* Content */}
      <section style={{ width: '100%', maxWidth: 1100, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        {/* Partner-Typen */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Arten von Partnerschaften</h2>
          <p className="highlight-desc" style={{ marginBottom: 12 }}>
            Unsere Kooperationen decken unterschiedliche Bereiche ab. Jede Partnerschaft verfolgt klare Ziele und ist transparent gestaltet.
          </p>
          <div style={{ display:'grid', gap:14 }}>
            {[
              { icon:'🛠️', title:'Technologie & Tools', desc:'Zugänge, Integrationen oder Spezialfunktionen für unsere Webplattform und Prozesse.' },
              { icon:'📢', title:'Promotion & Media', desc:'Gemeinsame Sichtbarkeit, Co-Branding, Content-Kooperationen und Interviews.' },
              { icon:'🎮', title:'Gaming / Server', desc:'Technische Ressourcen, Gameserver, Hosting oder Beta-Zugänge für Formate & Tests.' },
              { icon:'🤝', title:'Dienstleister', desc:'Grafik, Audio, Beratung, rechtliche oder organisatorische Unterstützung.' },
              { icon:'🏆', title:'Events & Aktionen', desc:'Gemeinsame Wettbewerbe, Formate, Challenges oder saisonale Kampagnen.' },
              { icon:'💼', title:'Sponsoren / Förderer', desc:'Finanzielle / materielle Unterstützung für Projekte, Infrastruktur und Community.' },
            ].map((p,i) => (
              <div key={i} style={{ border:'1px solid rgba(255,255,255,0.08)', padding:16, borderRadius:10, background:'rgba(255,255,255,0.03)' }}>
                <div style={{ fontWeight:600, display:'flex', alignItems:'center', gap:8 }}>
                  <span style={{fontSize:22}}>{p.icon}</span>{p.title}
                </div>
                <div style={{ fontSize:13, color:'#cbd5e1', marginTop:4 }}>{p.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Mehrwert für Partner */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Mehrwert für unsere Partner</h2>
          <ul style={{ listStyle:'none', margin:0, padding:0, display:'grid', gap:10 }}>
            <li style={{ display:'flex', gap:10 }}><span style={{fontSize:20}}>⭐</span><span><b>Diverse Zielgruppen</b> – Durch die diversität unserer Creator können wir Zielgerichtet bestimmte Zielgruppen ansprechen.</span></li>
            <li style={{ display:'flex', gap:10 }}><span style={{fontSize:20}}>📊</span><span><b>Saubere Prozesse</b> – Klare Abläufe, Feedback-Loops und definierte Kommunikationskanäle.</span></li>
            <li style={{ display:'flex', gap:10 }}><span style={{fontSize:20}}>🔄</span><span><b>Langfristigkeit</b> – Nachhaltige Kooperationen statt rein kurzfristiger Werbeaktionen.</span></li>
            <li style={{ display:'flex', gap:10 }}><span style={{fontSize:20}}>👥</span><span><b>Breit Aufgestellt</b> – Oft ist es effektiver über viele kleine statt einem großen Kanal zu Werben.</span></li>
            <li style={{ display:'flex', gap:10 }}><span style={{fontSize:20}}>🤗</span><span><b>Wertschätzung & Transparenz</b> – Offenheit über Zahlen, Wirkung und Möglichkeiten.</span></li>
            <li style={{ display:'flex', gap:10 }}><span style={{fontSize:20}}>🎯</span><span><b>Kuratierte Zielgruppe</b> – Zugang zu motivierten, strukturiert arbeitenden Creators & engagierter Community.</span></li>
            <li style={{ display:'flex', gap:10 }}><span style={{fontSize:20}}>🧩</span><span><b>Integration</b> – Möglichkeit Tools, Services oder Features direkt in Arbeitsabläufe einzubinden.</span></li>
          </ul>
        </div>

        {/* Kriterien für Partnerschaften */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Kriterien für eine Partnerschaft</h2>
          <p className="highlight-desc" style={{ marginBottom: 10 }}>
            Nicht jede Anfrage passt. Wir prüfen immer, ob die Zusammenarbeit unserem Leitbild entspricht und echten Mehrwert erzeugt.
          </p>
          <ul style={{ listStyle:'none', margin:0, padding:0, display:'grid', gap:10 }}>
            <li style={{ display:'flex', gap:10 }}><span style={{fontSize:20}}>✅</span><span><b>Integrität & Qualität</b> – Seriöses Auftreten, faire Bedingungen, klare Standards.</span></li>
            <li style={{ display:'flex', gap:10 }}><span style={{fontSize:20}}>🔍</span><span><b>Transparenz</b> – Offenheit bei Zielen, Kennzahlen und Rahmenbedingungen.</span></li>
            <li style={{ display:'flex', gap:10 }}><span style={{fontSize:20}}>🎯</span><span><b>Passung</b> – Relevanz für unsere Creator & Community anstatt generischer Masse.</span></li>
            <li style={{ display:'flex', gap:10 }}><span style={{fontSize:20}}>🌱</span><span><b>Nachhaltigkeit</b> – Fokus auf längerfristige, iterative Zusammenarbeit.</span></li>
            <li style={{ display:'flex', gap:10 }}><span style={{fontSize:20}}>🤝</span><span><b>Respekt & Fairness</b> – Gleichwertigkeit der Partnerschaft, kein toxisches Ungleichgewicht.</span></li>
          </ul>
        </div>

        {/* Fokus Ebenen */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Partner-Fokus: Netzwerk & ausgewählte Creator-Gruppen</h2>
          <p style={{ margin: '0 0 14px', color:'#cbd5e1' }}>
            Wir bauen Partnerschaften auf zwei Ebenen auf: (1) <b>Netzwerk-weite Kooperationen</b>, die Infrastruktur, Tools oder Events für alle verbessern – und (2) <b>gezielt kuratierte Gruppen von Creators</b>, die für Pilotphasen, Early-Access oder spezialisierte Formate besonders geeignet sind.
          </p>
          <div style={{ display:'grid', gap:12 }}>
            {[
              { icon:'🌐', title:'Netzwerk-Mehrwert', desc:'Verbesserung von Plattform-Funktionen, Abläufen oder gemeinsamen Formaten für möglichst viele Mitglieder.' },
              { icon:'🎯', title:'Gezielte Creator-Gruppen', desc:'Fokussierte Segmente (z.B. Schnitt / Streaming / Education) erhalten temporär besondere Tools oder Testzugänge.' },
              { icon:'🧪', title:'Pilot- & Beta-Phasen', desc:'Kleine Gruppen validieren Features früh – strukturiertes Feedback, klare Auswertung und Iteration.' },
              { icon:'⚖️', title:'Fairer Zugang', desc:'Auswahl basiert auf Aktivität, Qualität und konstruktivem Umgang – kein reiner Zahlen-Fokus.' },
              { icon:'📈', title:'Skalierbarkeit', desc:'Start in kleiner Gruppe – Ausweitung, wenn Wirkung & Nachhaltigkeit gegeben sind.' },
              { icon:'💬', title:'Transparente Kommunikation', desc:'Offenlegung von Ziel, Laufzeit, Kriterien und Weiterentwicklung gegenüber der Community.' }
            ].map((row,i) => (
              <div key={i} style={{ border:'1px solid rgba(255,255,255,0.08)', padding:14, borderRadius:10, background:'rgba(255,255,255,0.03)', display:'flex', gap:12 }}>
                <div style={{ fontSize:22 }} aria-hidden="true">{row.icon}</div>
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:600 }}>{row.title}</div>
                  <div style={{ fontSize:13, color:'#cbd5e1', marginTop:4 }}>{row.desc}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop:16, fontSize:13, color:'#93b4d1', background:'rgba(255,255,255,0.04)', padding:'10px 14px', borderRadius:8, border:'1px solid rgba(255,255,255,0.08)' }}>
            Hinweis: Eine Teilnahme an fokussierten Gruppen ist freiwillig – Bewerbungen oder Einladungen basieren auf konstruktivem Beitragsverhalten & passenden Use-Cases.
          </div>
        </div>

        {/* Ablauf einer Kooperation */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Ablauf einer Zusammenarbeit</h2>
          <ol style={{ margin:0, padding:'0 0 0 20px', display:'grid', gap:8 }}>
            <li><b>Anfrage / Erstkontakt:</b> Kurze Vorstellung & Ziele.</li>
            <li><b>Analyse & Passung:</b> Prüfung auf Werte, Zielgruppe & Nutzen.</li>
            <li><b>Konzeptphase:</b> Gemeinsame Definition von Umfang, Dauer & Formaten.</li>
            <li><b>Umsetzung / Launch:</b> Integration, Kommunikation & Aktivierung.</li>
            <li><b>Review & Optimierung:</b> Wirkung prüfen, Feedback sammeln, anpassen.</li>
            <li><b>Fortsetzung / Ausweitung:</b> Skalierung oder Abschluss mit sauberer Übergabe.</li>
          </ol>
        </div>

        {/* Beispielhafte Kooperationsformen */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Beispiele für Kooperationen</h2>
          <div style={{ display:'grid', gap:14 }}>
            {[
              { icon:'🧪', title:'Feature-Test', desc:'Beta-Funktion eines Tools wird von ausgewählten Mitgliedern getestet – strukturiertes Feedback & Verbesserungen.' },
              { icon:'🎙️', title:'Event-Sponsoring', desc:'Partner unterstützt Community-Challenge oder Seasonal Event mit Preisen oder Infrastruktur.' },
              { icon:'🔗', title:'API / Integration', desc:'Service wird direkt in automatisierte Workflows der Plattform eingebunden – Mehrwert für alle Beteiligten.' },
              { icon:'📦', title:'Bundle / Vorteil', desc:'Exklusive Konditionen für unsere Mitglieder – klare Richtlinien & transparente Vermittlung.' },
              { icon:'📰', title:'Content-Kooperation', desc:'Gemeinsame Guides, Interviews, Tutorials oder Themenserien mit Mehrwert-Fokus.' },
              { icon:'🎁', title:'Give-Aways & Gewinnspiele', desc:'Bereitstellen von Preisen oder Aktionen zur Steigerung der Community-Interaktion.' },
            ].map((ex,i) => (
              <div key={i} style={{ border:'1px solid rgba(255,255,255,0.08)', padding:16, borderRadius:10, background:'rgba(255,255,255,0.03)' }}>
                <div style={{ fontWeight:600, display:'flex', alignItems:'center', gap:8 }}>
                  <span style={{fontSize:20}}>{ex.icon}</span>{ex.title}
                </div>
                <div style={{ fontSize:13, color:'#cbd5e1', marginTop:4 }}>{ex.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ (Accordion like B2B/Jobs) */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">FAQ (Kurz)</h2>
          <div style={{ display: 'grid', gap: 10, width: '100%' }}>
            {faqs.map((item, i) => {
              const open = openFaq === i;
              const panelId = `partners-faq-${i}`;
              return (
                <div
                  key={i}
                  style={{
                    border: '1px solid rgba(255,255,255,0.12)',
                    borderRadius: 10,
                    background: 'rgba(255,255,255,0.03)',
                    width: '100%'
                  }}
                >
                  <button
                    onClick={() => setOpenFaq(open ? null : i)}
                    aria-expanded={open}
                    aria-controls={panelId}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                      background: 'transparent',
                      color: '#E2E5EA',
                      fontWeight: 600,
                      padding: '12px 14px',
                      paddingRight: 38,
                      border: 'none',
                      textAlign: 'center',
                      cursor: 'pointer'
                    }}
                  >
                    <span style={{ display: 'block', width: '100%', textAlign: 'center' }}>{item.q}</span>
                    <span aria-hidden="true" style={{ opacity: 0.85, position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)' }}>
                      {open ? '−' : '+'}
                    </span>
                  </button>
                  {open && (
                    <div id={panelId} style={{ padding: '0 14px 12px 14px', color: '#cbd5e1', lineHeight: 1.6 }}>
                      <p style={{ margin: 0, fontSize: 13 }}>{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Kontakt / CTA */}
        <div className="highlight-card" style={{ padding: 24 }}>
          <h2 className="highlight-title">Partnerschaft anfragen</h2>
          <p className="highlight-desc" style={{ marginBottom: 12 }}>
            Bereit für Austausch? Sende uns unverbindlich deine Ideen und Ziele – wir melden uns zeitnah.
          </p>
          <div style={{ display:'flex', gap: 8, flexWrap:'wrap' }}>
            <a className="hero-btn-primary" href="/kontakt" style={{ padding: '12px 18px', textDecoration:'none' }}>Kontakt aufnehmen</a>
            <a className="hero-btn-secondary" href="/register" style={{ padding: '12px 18px', textDecoration:'none' }}>Jetzt beitreten</a>
          </div>
          <div style={{ marginTop: 16 }}>
            <a href="#top" style={{ color: '#32CD89' }}>Nach oben</a>
          </div>
        </div>
      </section>
    </div>
  );
}
